// @flow strict

import { Avatar, List } from 'antd';
import * as React from 'react';
import { LuUser2 } from 'react-icons/lu';

function ReferredUserList({ users }) {

  return (
    <div className="mt-4">
      <List
        itemLayout="horizontal"
        dataSource={users}
        bordered
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar size={40} icon={<LuUser2 />} />}
              title={<span>{item?.fname + " " + item?.lname}</span>}
              description={<span>{item?.email}</span>}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default ReferredUserList;